import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/$regionId/')({
  beforeLoad: () => {
    throw redirect({
      to: '/dashboard/$regionId/messages',
      from: Route.fullPath,
      replace: true,
    })
  },
})
